import { useTranslation } from 'next-i18next';
import { SimilarPartsTable } from '@hub/bearing-hub/BearingHubPage/BearingsTable/SimilarPartsTable';
import { WidenImage } from '@hub/common/Widen/WidenImage';
import type { MetricType } from '@hub/libs/constants';
import type { ShapeDescriptor } from '@hub/bearing-hub/common/types';
import type {
  IbhCatalogArticleResponseDto,
  IbhCustomArticleResponseDto,
  IbhPartsResponseDto,
} from '@igus/iglidur-bearing-hub-api/src/data-contracts';

export interface SimilarPartsTabProps {
  articleData: IbhCustomArticleResponseDto | IbhCatalogArticleResponseDto;
  similarParts: IbhPartsResponseDto[];
  selectedShape: ShapeDescriptor;
  metricType: MetricType;
}

export const SimilarPartsTab = ({ articleData, similarParts, selectedShape, metricType }: SimilarPartsTabProps) => {
  const { t } = useTranslation(['common']);

  const { widenShortKeySchema, shapeKey } = selectedShape;

  const shapeDrawing = (
    <div className="mt-8">
      <WidenImage
        shortCode={widenShortKeySchema}
        title={t(`SHAPES.${shapeKey}.TITLE`, { ns: 'bearing-hub/bearingHub' })}
        filename={widenShortKeySchema}
        width={281}
        height={145}
      />
    </div>
  );

  return (
    <div>
      <div className="flex md:flex-row flex-col-reverse ">
        <div className="flex-grow">{t(`COMMON.SIMILAR_PARTS.TAB_TEXT`, { ns: 'bearing-hub/bearingHub' })}</div>
        <div>{shapeDrawing}</div>
      </div>
      <div className="flex flex-row justify-start items-center">
        <div className="hidden md:visible">
          {articleData.widenShortKey ? (
            <div className="flex justify-center z-5">
              <WidenImage
                shortCode={articleData.widenShortKey}
                title={articleData.articleNumber}
                filename={articleData.widenShortKey}
                width={72}
                height={72}
              />
            </div>
          ) : (
            <div className="flex justify-center z-5">
              <WidenImage
                shortCode={selectedShape.widenShortKeyIcon}
                title={articleData.articleNumber}
                filename={selectedShape.widenShortKeyIcon}
                width={48}
                height={48}
              />
            </div>
          )}
        </div>
        <div className="ml-3 hidden md:visible">
          <span className="font-bold z-5">{articleData.material.name}</span>
          <p className="z-5">
            {t(`PRODUCTION_METHODS.${articleData.productionMethod}`, { ns: 'bearing-hub/bearingHub' })}
          </p>
        </div>
      </div>
      <div className="mb-16">
        <SimilarPartsTable
          selectedShape={selectedShape}
          similarParts={similarParts}
          hideTitle
          showPrice
          showDeliveryTime
          showDimensionsAsCols={false}
          isLink
          dimensions={articleData.dimensions}
          metricType={metricType}
        />
      </div>
    </div>
  );
};
